// extracted by mini-css-extract-plugin
export default {"s1":"GreyStuff_s1__vlget"};